import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from './side/Sidebar';
import TopHeader from './side/TopHeader';
import '../css/Dashboard.css';
import { SERVER_URL } from '../../config/config';

const Dashboard = () => {
  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    axios.get(`${SERVER_URL}/admin/dashboard`)
      .then(res => setDashboard(res.data));
  }, []);

  if (!dashboard) return <div>Loading...</div>;

  return (
    <div className="dashboard">
      <div className="dashboard-content">
        <Sidebar />
        
        <div className="dashboard-main-content">
          <h1 className="dashboard-title">Dashboard</h1>

          
          <div className="stats-container">
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-info">
                <div className="stat-title">총 회원 수</div>
                <div className="stat-value">{dashboard.totalUsers}명</div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">📊</div>
              <div className="stat-info">
                <div className="stat-title">일일 접속자 수</div>
                <div className="stat-value">{dashboard.dailyUsers}명</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🎵</div>
              <div className="stat-info">
                <div className="stat-title">총 곡 업로드 수</div>
                <div className="stat-value">{dashboard.total_song_uploads}곡</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📈</div>
              <div className="stat-info">
                <div className="stat-title">일일 곡 업로드 수</div>
                <div className="stat-value">{dashboard.daily_song_uploads}곡</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">❓</div>
              <div className="stat-info">
                <div className="stat-title">일일 문의글 수</div>
                <div className="stat-value">{dashboard.daily_inquirys}개</div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">🤖</div>
              <div className="stat-info">
                <div className="stat-title">AI 평균 처리 소요 시간</div>
                <div className="stat-value">{dashboard.average_model_time}초</div>
              </div>
            </div>
          </div>
          
          <div className="dashboard-log-container">
            <div className="log-header">
              <div className="log-icon">📝</div>  
              <div className="dashboard-log-title">시스템 로그</div>
            </div>
            <div className="table-container">
              <div className="header-row" id="header-row" style={{ display: 'grid', gridTemplateColumns: '20% 15% 15% 50%' }}>
                <span className="cell">시간</span>
                <span className="cell">사용자</span>
                <span className="cell">레벨</span>
                <span className="cell">메시지</span>
              </div>
              <div className="data-entries">
                {dashboard.logs && dashboard.logs.map((log, idx) => (
                  <div className="table-row" key={idx} style={{ display: 'grid', gridTemplateColumns: '20% 15% 15% 50%' }}>
                    <span className="cell">
                      {new Date(log.log_time).toLocaleString('ko-KR', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                      })}
                    </span>
                    <span className="cell">{log.username}</span>
                    <span className={`cell log-level ${log.log_level.toLowerCase()}s`}>{log.log_level}</span>
                    <span className="cell" style={{ justifyContent: 'left' }}>{log.message}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Dashboard; 